(function () {
	const initProductAccordion = () => {
		document.querySelectorAll('.about__accordion-toggle').forEach((toggle) => {
			if (toggle.dataset.accordionBound === 'true') {
				return;
			}

			toggle.dataset.accordionBound = 'true';
			toggle.addEventListener('click', () => {
				const description = toggle.nextElementSibling;
				const isActive = toggle.classList.contains('active');

				toggle.classList.toggle('active', !isActive);

				if (!description || !description.classList.contains('about__accordion-description')) {
					return;
				}

				description.style.display = isActive ? 'none' : 'block';
			});
		});
	};

	document.addEventListener('shopify:section:load', initProductAccordion);
	initProductAccordion();
})();
